import { FC, ReactNode } from 'react';
import { styled } from '@robocorp/theme';

export interface ListContentProps {
  /**
   * @ignore
   */
  id?: string;
  /**
   * @ignore
   */
  className?: string;
  /**
   * List content type
   */
  type?: 'container' | 'text' | 'icon';
  /**
   * List item secondary text prepended before primary text
   */
  secondaryTop?: string | React.ReactElement;
  /**
   * List item secondary text appended after primary text
   */
  secondary?: string | React.ReactElement;
  /**
   * Is list content visible only on item hover
   */
  hover?: boolean;
  /**
   * @ignore
   */
  children?: ReactNode;
}

/**
 * List content component
 */
const StyledListContent = styled.div<ListContentProps>`
  flex: ${({ type }) => (type === 'icon' ? 'auto' : '1')};
  flex-grow: ${({ type }) => (type === 'icon' ? '0' : '1')};
  display: flex;
  align-items: center;
  min-height: 28px;
  word-break: break-word;
  overflow-wrap: break-word;

  > * {
    flex-grow: 1;
  }
`;

const TextStyled = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 20px;
  small {
    color: ${({ theme }) => theme.colors.content.subtle.color};
    line-height: 16px;
  }
`;

const ListContent: FC<ListContentProps> = ({
  children,
  hover,
  secondary,
  secondaryTop,
  type,
  ...rest
}) => {
  return (
    <StyledListContent className={hover ? 'hover' : ''} type={type} {...rest}>
      {type === 'text' ? (
        <TextStyled>
          {secondaryTop && <small>{secondaryTop}</small>}
          {children}
          {secondary && <small>{secondary}</small>}
        </TextStyled>
      ) : (
        children
      )}
    </StyledListContent>
  );
};

ListContent.defaultProps = {
  type: 'container',
};

export default ListContent;
